import Image from '@/components/UI/Image';
import { useGlobal } from '@/utils/useGlobal';
import { Select as AntSelect } from 'antd';
import { forwardRef } from 'react';
import css from './select.module.scss';
type SelectType = {
    text: string;
    value: string;
    disabled?: boolean | undefined;
};

const Select = ({ data, selType = '', haveSelect = [], ...rest }: any, ref: any) => {
    const { Option, OptGroup } = AntSelect;
    const { useState } = useGlobal();
    // 下拉框展示时右侧向下的箭头需要旋转180°向上
    const [reverIcon, setRevertIcon] = useState(false);
    const changeVisibleDropdown = (value: boolean) => {
        setRevertIcon(value);
    };
    const classList = [css.efSelect];
    const props = { ...rest };
    if (rest.className) {
        classList.push(rest.className);
        props.className = classList;
    }
    // antd 的 select 已不再支持 dropdownClassName 属性,改为 popupClassName
    // if (props.dropdownClassName) {
    //     props.popupClassName = props.dropdownClassName
    //     delete props.dropdownClassName
    // }

    return (
        <div className={reverIcon ? 'revertIconSelect' : ''}>
            <AntSelect {...props} ref={ref} onDropdownVisibleChange={changeVisibleDropdown}>
                {selType === '' &&
                    data &&
                    data.map((item: SelectType) => (
                        <Option key={item.value} value={item.value} {...(item.disabled ? { disabled: item.disabled } : {})}>
                            {item.text}
                        </Option>
                    ))}
                {selType === 'optGroup' &&
                    data &&
                    data.map((item: any, i: number) => (
                        <OptGroup label={item.series} key={item.series}>
                            {item.arr.map((list: any, j: number) => (
                                <Option value={list.key} key={list.key} disabled={haveSelect.some((id: any) => id == list.key)}>
                                    <span className="title"> {list.text}</span>
                                    <span className={list.skuId ? 'imgs' : 'imgs imgs1'}>
                                        {list.images && <Image src={list.images} width={54} height={34} className="fullImgs" alt={list.key} />}
                                    </span>
                                </Option>
                            ))}
                        </OptGroup>
                    ))}
            </AntSelect>
        </div>
    );
};

Select.Option = AntSelect.Option;

export default forwardRef(Select);
